import { Box, Stack, Typography } from '@mui/material';

// ----------------------------------------------------------------------

interface Props {
  data?: {
    title: string;
    subtitle?: string;
    rows?: { title: string; subtitle: string }[];
  };
}

const SimpleStatsTile: React.FC<Props> = ({ data }) => {
  return (
    <>
      <Box
        sx={{ alignContent: 'center', height: '100%', p: 2, backgroundColor: (theme) => theme.palette.branded.paper }}
        textAlign={'center'}
      >
        <Typography variant={!data?.rows ? "h1" : "h3"}>{data?.title}</Typography>
          {data?.subtitle && <Typography variant="body2">{data?.subtitle}</Typography>}
      </Box>
      {data?.rows && <Stack direction={'row'} spacing={2} justifyContent={'space-around'} sx={{ p: 2 }}>
        {data?.rows?.map((item, idx) => (
          <Box textAlign={'center'} key={idx}>
            <Typography variant="h3">{item?.title}</Typography>
            <Typography variant="body2">{item?.subtitle}</Typography>
          </Box>
        ))}
      </Stack>}
    </>
  );
};

export default SimpleStatsTile;
